
import PropTypes from '../_util/vue-types'
export default {
  props: {
    label: PropTypes.any,
  },
  isSelectOptGroup: true,
}




// WEBPACK FOOTER //
// ./components/vc-select/OptGroup.jsx